/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_SalesInputs */

const en_nav_sales = /** @type {(inputs: Nav_SalesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sales`)
};

const es_nav_sales = /** @type {(inputs: Nav_SalesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ventas`)
};

/**
* | output |
* | --- |
* | "Sales" |
*
* @param {Nav_SalesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const nav_sales = /** @type {((inputs?: Nav_SalesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_SalesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_sales(inputs)
	return es_nav_sales(inputs)
});